export * from './person-panel.component'
export * from './person-panel-orgperson.component'



// WEBPACK FOOTER //
// ./src/app/shared/components/person-panel/index.ts